<div class="my-aha-container">
  <!-- Top Panel -->
  <div
    class="top-panel horizontal-focusable-container"
    (keydown)="onKeyDown($event)"
  >
    <!-- Left: Profile title and icons -->
    <div class="left">
      <div class="title">{{ "profiles_title" | translate }}</div>
      <div class="profiles profiles-container">
        <app-profile-card
          *ngFor="
            let item of profileData;
            let i = index;
            let isLast = last;
            trackBy: trackByIndex
          "
          [label]="
            item.firstName.length > 8
              ? item.firstName.substring(0, 8) + '...'
              : item.firstName
          "
          [index]="i"
          [isLast]="isLast"
          [selected]="selectedProfile.contactID === item.contactID"
          [profile]="item"
          (profileClick)="onProfileClick($event)"
        >
        </app-profile-card>
      </div>
    </div>

    <!-- Right: User info + Buttons -->
    <div class="right">
      <div class="user-info">
        <p
          class="user-account"
          [innerHTML]="maskedMobileNumber || maskedEmail"
        ></p>
        <div
          class="user-plan"
          [ngClass]="showPlanAction && !isCancelledUser ? 'basic' : 'gold'"
        >
          <span class="plan-prefix">{{ planPrefix | translate }}</span>
          <span class="plan-name">{{ planName | translate }}</span>
        </div>
      </div>
      <div class="button-container">
        <app-icon-button
          *ngIf="showPlanAction !== null"
          [label]="getTranslatedSubscriptionName() | translate"
          [mode]="showPlanAction"
          (clicked)="onSubcriptionClick()"
        >
        </app-icon-button>

        <app-icon-button
          [label]="'menu_settings' | translate"
          [icon]="'my-aha-settings'"
          (clicked)="onSettingsClick()"
        >
        </app-icon-button>
      </div>
    </div>
  </div>

  <!-- Divider -->
  <hr class="divider" />

  <!-- Content Area -->
  <ng-container *ngIf="hasPersonalizedContent !== null">
    <div
      *ngIf="!hasPersonalizedContent; else personalizedContent"
      class="content"
    >
      <app-myaha-explore
        [isFromLanguageSelection]="isFromLanguageSelection"
        [isFromSettings]="isFromSettings"
        [selectedProfileIndex]="selectedProfileIndex"
      ></app-myaha-explore>
    </div>
    <ng-template #personalizedContent>
      <div class="data-container" (keydown.arrowLeft)="onArrowLeft()">
        <app-my-aha-main
          [isFromLanguageSelection]="isFromLanguageSelection"
          [isFromSettings]="isFromSettings"
          [selectedProfileIndex]="selectedProfileIndex"
        ></app-my-aha-main>
      </div>
    </ng-template>
  </ng-container>
</div>
